import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Core2Config } from "../../../shared";
import { EndpointModel } from "../../../../../../../models/mongodbSchema/schema";

@Injectable({ providedIn: "root" })
export class LazadaAuthService {
    constructor(private httpClient: HttpClient) { }
    private form: HTMLFormElement;

    signIn(endpointHdr: EndpointModel, tenantCode: string, aiLedgerUrl:string) {
        let oauth2Endpoint =  Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.UCC_MODULE + "lazada-api/auth"; 
        this.form = document.createElement('form');
        this.form.setAttribute('method', 'GET'); // Send as a GET request.
        this.form.setAttribute('action', oauth2Endpoint);
        let params = { "endpoint": JSON.stringify(endpointHdr), "tenantCode": tenantCode };
        this.addFormInput(params)
        document.body.appendChild(this.form);
        this.form.submit();
    }

    addFormInput(params: any) {
        for (var p in params) {
            let input = document.createElement('input');
            input.setAttribute('type', 'hidden');
            input.setAttribute('name', p);
            input.setAttribute('value', params[p]);
            this.form.appendChild(input);
        }
    }
}
